<template>
    <div>
       <HeaderTeam header="รายงานและการสรุปยอด" :img_header="header_image" link_back="summary"/>
       <MenuTeamReportAndSummaryList/>
       <EditEmployeeSummaryList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/dashboard.png'
import HeaderTeam from '@/components/menuadmin/team/teamheader/HeaderTeam.vue'
import MenuTeamReportAndSummaryList from '@/components/menuadmin/team/teamreportandsummary/MenuTeamReportAndSummaryList.vue'
import EditEmployeeSummaryList from '@/components/menuadmin/team/teamreportandsummary/EditEmployeeSummaryList.vue'
export default {
    name:'editEmployeeSummary',
    components:{
        HeaderTeam,
        MenuTeamReportAndSummaryList,
        EditEmployeeSummaryList,
    },
    data(){
        return{
            header_image:HeaderImage
        }
    }
}
</script>